import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import HeaderContainer from '../Header';
import Container from '../../components/Container';
import Gallery from '../Gallery';
import RatingBadge from '../RatingBadge';
import { getHotelRoulette } from '../../store/selectors/hotel';
import ReviewsMobile from '../Reviews/ReviewsMobile';
import HintFactory from '../../../../components/Hint/HintFactory';
import FortunaJumbotron from '../../components/FortunaJumbotron';
import PriceFixedButton from '../PriceFixedButton';

const LayoutMobile = ({ isRoulette }) => (
  <StyledContainer className="hotel-mobile" paddingBottom>
    <HintFactory autoPosition events attribute="data-text-hint" isMobile />

    <div>
      <Container isMobile white marginBottom>
        <HeaderContainer />
      </Container>
      <Container isMobile fullWidth>
        {isRoulette ? (
          <FortunaJumbotron isMobile />
        ) : (
          <>
            <RatingBadge isMobile />
            <Gallery />
          </>
        )}
      </Container>
    </div>

    <ReviewsMobile />

    <PriceFixedButton />
  </StyledContainer>
);

LayoutMobile.propTypes = {
  isRoulette: PropTypes.bool.isRequired,
};

const StyledContainer = styled.div`
  position: relative;
`;

const mapStateToProps = (state) => ({
  isRoulette: getHotelRoulette(state),
});

export default connect(mapStateToProps)(LayoutMobile);
